(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["individual-boxing"] && !Shopify.designMode) return;
  try {
    (() => {
    const variantId = 45923044229255;
    const root = window.Shopify?.routes?.root || '/';
    let queue = Promise.resolve();
    let busy = false;
    let pending = 0;
    let allowingSubmit = false;
    const panels = () => [...document.querySelectorAll('individual-boxing')];
    const boxes = cart => cart.items.filter(item => item.variant_id === variantId);
    const count = cart => cart.items.reduce((total, item) => total + (item.product_type === 'Tap Handles' && item.variant_id !== variantId ? item.quantity : 0), 0);
    async function request(path, body) {
      const response = await fetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || 'Cart update failed');
      return result;
    }
    function setBusy(value) {
      busy = value;
      panels().forEach(panel => {
        panel.setAttribute('aria-busy', String(value));
        panel.querySelector('input').disabled = value;
      });
    }
    function showError() {
      panels().forEach(panel => {
        panel.hidden = false;
        const error = panel.querySelector('.boxing-error');
        error.textContent = panel.dataset.error;
        error.hidden = false;
      });
    }
    function sections() {
      const list = [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble', selector: '#cart-icon-bubble' }];
      for (const id of ['main-cart-items', 'main-cart-footer']) {
        const element = document.getElementById(id);
        if (element) list.push({ id: element.dataset.id, selector: '#' + id });
      }
      return list;
    }
    async function refresh(cart) {
      const list = sections();
      const url = new URL(window.location.href);
      url.searchParams.set('sections', list.map(section => section.id).join(','));
      const response = await fetch(url.toString(), { cache: 'no-store' });
      if (!response.ok) throw new Error('Cart rendering failed');
      const html = await response.json();
      const focusId = document.activeElement?.id;
      for (const section of list) {
        const target = document.querySelector(section.selector);
        if (!target || !html[section.id]) continue;
        const parsed = new DOMParser().parseFromString(html[section.id], 'text/html');
        const source = parsed.querySelector(section.selector);
        if (source) target.innerHTML = source.innerHTML;
        else if (section.id === 'cart-icon-bubble') target.innerHTML = parsed.querySelector('.shopify-section')?.innerHTML || html[section.id];
      }
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);
      const drawer = document.querySelector('cart-drawer');
      document.getElementById('CartDrawer-Overlay')?.addEventListener('click', () => drawer?.close());
      if (drawer?.classList.contains('active') && typeof trapFocus === 'function') trapFocus(document.getElementById('CartDrawer'), drawer.querySelector('.drawer__close'));
      if (focusId) document.getElementById(focusId)?.focus();
    }
    async function reconcile(choice) {
      setBusy(true);
      try {
        let cart = await request('cart.js');
        const existing = boxes(cart);
        const handles = count(cart);
        const wanted = handles >= 10 && (choice ?? existing.length > 0) ? handles : 0;
        const updates = {};
        existing.forEach((item, index) => { if (item.quantity !== (index === 0 ? wanted : 0)) updates[item.key] = index === 0 ? wanted : 0; });
        if (Object.keys(updates).length) cart = await request('cart/update.js', { updates });
        if (wanted > 0 && existing.length === 0) {
          await request('cart/add.js', { items: [{ id: variantId, quantity: wanted }] });
          cart = await request('cart.js');
        }
        await refresh(cart);
        return cart;
      } catch (error) {
        console.error('Individual boxing:', error);
        showError();
        throw error;
      } finally { setBusy(false); }
    }
    function schedule(choice) {
      pending++;
      const next = queue.catch(() => {}).then(() => reconcile(choice));
      queue = next.finally(() => { pending--; });
      queue.catch(() => {});
      return next;
    }
    class IndividualBoxing extends HTMLElement {
      connectedCallback() {
        this.querySelector('input').addEventListener('change', event => {
          event.stopPropagation();
          const selected = event.target.checked;
          schedule(selected).catch(() => { if (this.isConnected) event.target.checked = !selected; });
        });
        const handles = Number(this.dataset.handles);
        const quantity = Number(this.dataset.boxes);
        if (!busy && !pending && quantity > 0 && (handles < 10 || quantity !== handles)) schedule().catch(() => {});
      }
    }
    if (!customElements.get('individual-boxing')) customElements.define('individual-boxing', IndividualBoxing);
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, () => schedule().catch(() => {}));
    window.CraftMarkBeforeCheckout = () => schedule();
    document.addEventListener('submit', event => {
      if (window.CraftMarkGuard) return;
      if (allowingSubmit || !event.submitter?.matches('[name="checkout"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const form = event.target;
      const submitter = event.submitter;
      schedule().then(() => {
        allowingSubmit = true;
        const liveForm = form.id ? document.getElementById(form.id) : form;
        const liveButton = submitter.id ? document.getElementById(submitter.id) : submitter;
        if (liveForm && liveButton) liveForm.requestSubmit(liveButton);
        else window.location.assign(root + 'checkout');
        allowingSubmit = false;
      }).catch(() => {});
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
